import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { ItemSetupName } from '@app/shared/pipes/item-setup-name.pipe';
import { CommonService, DocumentService } from '@app/shared/services';
import { Subscription, timer } from 'rxjs';
import { ItemsToSetUpListSubjectService } from './items-to-set-up.subject';
import { MatDialog } from '@angular/material/dialog';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { take } from 'rxjs/operators';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'items-to-set-up',
  templateUrl: './items-to-set-up.component.html',
  styleUrls: ['./items-to-set-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemsToSetUpComponent implements OnInit, OnDestroy {
  @Input() itemsToSetup;
  @Input() currentUserId;
  @Input() sharingMode;
  @Input() mode;
  @Input() currentFormId;
  @Input() formsList;
  @Input() data;
  @Input() hideManageButton = false;
  @Input() enable_template_linking_filter = false;

  value_change = undefined;
  subscription = new Subscription();
  panelOpenState: boolean = true;
  @Output() itemsToSetUpEvent = new EventEmitter<any>();
  @Output() itemsToSetUpListAttachmentEvent = new EventEmitter<any>();
  @Output() itemsToSetUpListRolePlayersEvent = new EventEmitter<any>();
  @Output() formStatusEvent = new EventEmitter<any>();
  @Output() itemsToSetUpListRapidAPIEvent = new EventEmitter<any>();
  @Output() itemsToSetUpListSharingEvent = new EventEmitter<any>();
  @Output() itemsToSetUpListNoteEvent = new EventEmitter<any>();
  @Output() itemsToSetUpListCompleteAllEvent = new EventEmitter<any>();
  private itemSetupName: ItemSetupName;
  notificationLoading: boolean = true;
  createdCount = 0;
  createdCount_link_count = 0;
  createdCount_non_link_count = 0;
  current_template = {};

  itemsToSetUpList = [];
  rolePlayersJsonData = [];
  linkedTemplateData = [];
  CompletionPercentage = 0;
  Completion_link_Percentage = 0;
  currentUser = null;
  nonVaultFormsOrigins = ['contact', 'password'];
  originalItemsToSetUpList: any[] = [];
  selectedCategory: string = 'All';
  allAttributeData: any[] = [];

  constructor(
    private documentService: DocumentService,
    private _commonService: CommonService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private loginService: LoginStoreEffects,
    private http: HttpClient,
    private itemsToSetUpListSubjectService: ItemsToSetUpListSubjectService
  ) {
    this.itemSetupName = new ItemSetupName();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  callAction(item) {
    this.itemsToSetUpEvent.emit(item);
  }
  removeSuggestion(item) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Remove suggestion',
        materialIcon: 'remove-info',
        text: `Are you sure you want to remove the suggestion? This action cannot be undone.`,
        proceedTitle: 'Remove',
        showCancelBtn: true,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.documentService
              .updateItemsToSetUpList({
                id: item.id,
                status: 'complete',
              })
              .subscribe((res) => {
                if (this.selectedCategory && this.selectedCategory.toLowerCase() === 'report') {
                  this.originalItemsToSetUpList = this.originalItemsToSetUpList.filter((i) => i.id !== item.id && i.status !== 'complete');
                  if (this.originalItemsToSetUpList.length > 0) {
                    this.itemsToSetUpList = this.originalItemsToSetUpList.filter((i) => i.category === 'report');
                  } else {
                    this.itemsToSetUpList = [];
                  }
                } else if (this.selectedCategory && this.selectedCategory.toLowerCase() === 'links') {
                  this.originalItemsToSetUpList = this.originalItemsToSetUpList.filter((i) => i.id !== item.id && i.status !== 'link');
                  if (this.originalItemsToSetUpList.length > 0) {
                    this.itemsToSetUpList = this.originalItemsToSetUpList.filter((i) => i.category === 'link');
                  } else {
                    this.itemsToSetUpList = [];
                  }
                } else {
                  this.getItemSetupList();
                }
                this.cd.detectChanges();
              })
          );
        }
      })
    );
  }
  itemsToUpDate = signal(null);
  finishedCount = 0;
  callActionUpdate(id, value, vault_user_form_uploads_id = []) {
    let itemsToSetUp = this.itemsToSetUpList.find((x) => x.id == id);
    const transformedItemSetupName = this.itemSetupName.transform(
      itemsToSetUp,
      itemsToSetUp.type == 'role_players'
        ? this.rolePlayersJsonData
        : itemsToSetUp.type == 'financial_attributes'
        ? this.allAttributeData
        : itemsToSetUp.type == 'insurance_attributes'
        ? this.insuranceAttributeData
        : [],
      this.linkedTemplateData,
      this.current_template
    );
    const transformedItemSetupNameString = transformedItemSetupName
      .toString()
      .replace(/\(\d+\)/, '')
      .trim();
    const SETUP_LABEL_MAPPING = {
      'general information': 'General Information',
      description: 'Description',
      documents: 'Documents',
      'live data feed': itemsToSetUp.sub_type,
      'add note': itemsToSetUp.sub_type,
      checklist: 'Checklist',
      share: 'Share Settings',
    };
    const mappedSetupLabel = transformedItemSetupNameString
      ? SETUP_LABEL_MAPPING[Object.keys(SETUP_LABEL_MAPPING).find((key) => transformedItemSetupNameString.toLowerCase().includes(key))] ||
        transformedItemSetupNameString
      : '';
    this.subscription.add(
      this.documentService
        .updateItemsToSetUpList({
          id: id,
          status: value,
          vault_user_form_uploads_id: vault_user_form_uploads_id,
          setupLabel: mappedSetupLabel,
        })
        .subscribe(() => {
          let findIndex = this.itemsToSetUpList.findIndex((x) => x.id == id);
          let itemsToSetUp = this.itemsToSetUpList.find((x) => x.id == id);
          if (findIndex >= 0) {
            if (itemsToSetUp?.status != value) {
              this.itemsToUpDate.set(itemsToSetUp);
            }
            this.subscription.add(
              timer(1200)
                .pipe(take(1))
                .subscribe(() => {
                  this.itemsToSetUpList = this.itemsToSetUpList.map((item, index) => (index === findIndex ? { ...item, status: value } : item));
                  this.itemsToUpDate.set(null);
                  this.handleCounts();
                  if (this.itemsToSetUpList[findIndex].type === 'role_players') {
                    this.itemsToSetUpListRolePlayersEvent.emit({
                      list: this.itemsToSetUpList?.filter((x) => x.type == 'role_players'),
                    });
                  }
                  if (this.itemsToSetUpList[findIndex].type === 'share') {
                    this.itemsToSetUpListSharingEvent.emit(this.itemsToSetUpList?.filter((x) => x.type == 'share'));
                  }
                  // if (this.itemsToSetUpList[findIndex].type === 'note')
                  //   this.itemsToSetUpListNoteEvent.emit(this.itemsToSetUpList?.filter((x) => x.type == 'note'));

                  this.getItemSetupList();
                  this.cd.detectChanges();
                })
            );
          }
          this.formStatusEvent.emit({});
          this.cd.detectChanges();
        })
    );
  }
  handleCounts() {
    this.createdCount = this.itemsToSetUpList.filter((x) => x.status == 'created').length;
    this.createdCount_link_count = this.itemsToSetUpList.filter(
      (x) => x.status == 'created' && (x.type == 'template_linking' || x.type == 'location')
    ).length;
    this.createdCount_non_link_count = this.itemsToSetUpList.filter((x) => x.status == 'created').length;
    this.finishedCount = this.itemsToSetUpList.filter((x) => x.status == 'finish').length;
    this.calculateCompletionPercentage();
  }
  ngOnInit(): void {
    this.current_template = this.formsList.find(
      (x) => x.id == (this.data?.fid ? this.data.fid : this.data.form_id ? this.data.form_id : this.data.vault_form_id)
    );
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.currentUser = state;
      })
    );

    this.subscription.add(
      this._commonService.getLinkedTemplatedJSON().subscribe((res = []) => {
        this.linkedTemplateData = res;
        this.cd.detectChanges();
      })
    );
    this.subscription.add(
      this._commonService.getRolePlayersJsonData().subscribe((data) => {
        this.rolePlayersJsonData = [...data];
        this.cd.detectChanges();
      })
    );

    // this.documentService.setupItemsSubject.subscribe((val) => {
    //   const noteSetup = this.itemsToSetUpList.find((x) => x.type.toLowerCase() === 'note');
    //   if (noteSetup) {
    //     if (val?.updateNoteSetup && noteSetup?.status == 'created') {
    //       this.callActionUpdate(noteSetup?.id, 'complete');
    //     }
    //     if (val?.getNoteSetup && noteSetup?.status == 'complete') {
    //       this.callActionUpdate(noteSetup?.id, 'created');
    //     }
    //   }
    // });

    this.handleJson();
    this.handleInsuranceJson();
    this.getItemSetupList();
  }
  getItemSetupList() {
    this.subscription.add(
      this.documentService.getItemsToSetUpList(this.currentUserId, this.currentFormId).subscribe((res) => {
        this.itemsToSetUpList = res;
        this.sortItemsToSetUpList();
        this.itemsToSetUpListSubjectService.handleItemsToSetUpList(res);
        this.notificationLoading = false;
        this.itemsToSetUpList.forEach((element, index) => {
          if (element.type == 'general') {
            this.itemsToSetup.controls.generalSection.setValue(element.status == 'complete' ? true : false);
          }
          if (element.type == 'description') {
            this.itemsToSetup.controls.descriptionSection.setValue(element.status == 'complete' ? true : false);
          }
        });

        this.itemsToSetUpListAttachmentEvent.emit({
          list: this.itemsToSetUpList?.filter((x) => x.type === 'attach' && x.status !== 'complete'),
        });
        this.itemsToSetUpListRolePlayersEvent.emit({
          list: this.itemsToSetUpList?.filter((x) => x.type === 'role_players'),
        });
        this.itemsToSetUpListRapidAPIEvent.emit(this.itemsToSetUpList?.filter((x) => x.type === 'api'));
        this.itemsToSetUpListSharingEvent.emit(this.itemsToSetUpList?.filter((x) => x.type === 'share'));
        // this.itemsToSetUpListNoteEvent.emit(this.itemsToSetUpList?.filter((x) => x.type === 'note'));
        this.createdCount = this.itemsToSetUpList.filter((x) => x.status === 'created').length;
        this.createdCount_link_count = this.itemsToSetUpList.filter(
          (x) => x.status === 'created' && (x.type === 'template_linking' || x.type === 'location')
        ).length;
        this.createdCount_non_link_count = this.itemsToSetUpList.filter(
          (x) => x.status === 'created' && x.type !== 'template_linking' && x.type !== 'location'
        ).length;

        this.finishedCount = this.itemsToSetUpList.filter((x) => x.status == 'finish').length;
        this.calculateCompletionPercentage();
        if (this.enable_template_linking_filter) {
          this.filterItems('Links');
        }
        this.cd.detectChanges();
      })
    );
  }
  sortItemsToSetUpList(): void {
    const typePriority = [
      'role_players',
      'api',
      'insurance_attributes',
      'financial_attributes',
      'general',
      'description',
      'template_linking',
      'location',
      'attach',
      'note',
      'share',
    ];

    this.itemsToSetUpList = [...this.itemsToSetUpList].sort((a, b) => {
      const priorityA = typePriority.indexOf(a.type);
      const priorityB = typePriority.indexOf(b.type);

      // If types are found in the priority list, sort by their index.
      if (priorityA !== -1 && priorityB !== -1) {
        return priorityA - priorityB;
      }
      // If one type is in the priority list but the other is not, the one in the list comes first.
      if (priorityA !== -1) return -1;
      if (priorityB !== -1) return 1;

      // If both types are not in the list, keep the original order.
      return 0;
    });
    this.originalItemsToSetUpList = [...this.itemsToSetUpList];
  }
  filterItems(category: string) {
    this.selectedCategory = category;
    if (category === 'All') {
      this.itemsToSetUpList = [...this.originalItemsToSetUpList];
    } else if (this.selectedCategory === 'Links') {
      this.itemsToSetUpList = this.originalItemsToSetUpList.filter((item) => item.category === 'link' && item.status !== 'complete');
    } else {
      this.itemsToSetUpList = this.originalItemsToSetUpList.filter((item) => item.category === 'report' && item.status !== 'complete');
    }
  }
  calculateCompletionPercentage() {
    if (!Array.isArray(this.itemsToSetUpList)) {
      throw new Error('Input must be an array');
    }
    // const completedItems = this.itemsToSetUpList.filter(
    //   (item) => item.status === 'complete' && item.type != 'template_linking' && item.type != 'location'
    // );
    // const totalCOunt = this.itemsToSetUpList.filter((item) => item.type != 'template_linking' && item.type != 'location');
    // const completionPercentage = (completedItems.length / totalCOunt.length) * 100;
    // this.CompletionPercentage = Math.ceil(completionPercentage);
    const completeItems = this.itemsToSetUpList.filter((item) => item.status === 'complete');
    const totalCount = this.itemsToSetUpList;
    const totalCompletionPercentage = (completeItems.length / totalCount.length) * 100;
    this.CompletionPercentage = Math.ceil(totalCompletionPercentage);

    const completedItems_linking = this.itemsToSetUpList.filter(
      (item) => item.status === 'complete' && (item.type == 'template_linking' || item.type == 'location')
    );
    const totalCOunt_linking = this.itemsToSetUpList.filter((item) => item.type == 'template_linking' || item.type == 'location');
    const Completion_link_Percentage = (completedItems_linking.length / totalCOunt_linking.length) * 100;
    this.Completion_link_Percentage = Math.ceil(Completion_link_Percentage);

    this.cd.detectChanges();
  }
  updateAttachment(mark_complete) {
    try {
      const itemsToSetUp = this.itemsToSetUpList.find((x) => x.type === 'attach');
      this.callActionUpdate(itemsToSetUp.id, mark_complete ? 'complete' : 'created');
    } catch (error) {}
  }
  closeSetupItems() {
    this.subscription.add(
      this.documentService
        .updateItemsToSetUpListStatusToFinish({
          formId: this.currentFormId,
          userId: this.currentUserId,
        })
        .subscribe(() => {
          this.getItemSetupList();
        })
    );
  }
  handleJson() {
    this.subscription.add(
      this.documentService.getFinancialAttribute().subscribe(
        (data) => {
          this.allAttributeData = data;
          this.cd.detectChanges();
        },
        (error) => {
          console.error(error);
        }
      )
    );
  }
  insuranceAttributeData;
  handleInsuranceJson() {
    this.subscription.add(
      this.documentService.getInsuranceAttribute().subscribe(
        (data) => {
          this.insuranceAttributeData = data;
          this.cd.detectChanges();
        },
        (error) => {
          console.error(error);
        }
      )
    );
  }
  findInsuranceVaultForm(param: string): any {
    const json = this.insuranceAttributeData;
    if (json) {
      for (let key in json) {
        if (typeof json[key] === 'object') {
          if (json[key]?.vault_form_code?.toLowerCase() === param) {
            return key;
          }
        }
      }
    }
    return json ?? null;
  }

  findVaultForm(param: string): any {
    const json = this.allAttributeData;
    if (json) {
      // eslint-disable-next-line @typescript-eslint/no-for-in-array
      for (let key in json) {
        if (typeof json[key] === 'object') {
          if (json[key]?.vault_form_code?.toLowerCase() === param) {
            return key;
          }
        }
      }
    }
    return json ?? null;
  }
  markComplete() {
    this.createdCount_non_link_count = 0;
    this.subscription.add(
      this.documentService
        .updateItemsToSetUpLinkedItemComplete({
          vault_user_form_id: this.currentFormId,
          type: 'template_setup',
        })
        .subscribe((res) => {
          this.getItemSetupList();
          this.itemsToSetUpListCompleteAllEvent.emit({});
          this.createdCount_non_link_count = 0;
        })
    );
  }
}
